import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default function ContentContainer(props) {
  const { children, className, hasMaxWidth, noTopBottomMargin, ...rest} = props;

  return (
    <div
      data-component="ContentContainer"
      className={cx("rec-content-container", className, {
        'no-max-width' : !hasMaxWidth,
        'no-top-bottom-margin' : noTopBottomMargin
      })}
      {...rest}>
      {children}
    </div>
  );
}

ContentContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  hasMaxWidth: PropTypes.bool,
  noTopBottomMargin: PropTypes.bool
};

ContentContainer.defaultProps = {
  hasMaxWidth: true,
  noTopBottomMargin: false
};
